export const enum AuctionState {
    Unknown = "Unknown",
    NotStarted = "NotStarted",
    InviteOnly = "InviteOnly",
    DutchAuction = "DutchAuction"
}